module.exports = __webpack_public_path__ + "static/img/Wood.8f47ee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/misc_3d/Wood.jpg
// module id = gIq/
// module chunks = 1